// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"94":"Login","138":"profile","594":"demo"}[chunkId] || chunkId) + "." + {"94":"4d0eece7","138":"41bbfa70","594":"5cb65a39","827":"0698160c"}[chunkId] + ".js";
};